module.exports = __webpack_public_path__ + "static/media/logout.913768d0.svg";